<template>
  <div class="text-container">
    <p v-html="content" class="content" />
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
    content () {
      let content = ''
      if (this.value?.items?.length > 0) {
        content = this.value.items[0].text
      }
      return content
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.text-container {
  line-height: 2;
}
</style>
